import axios from "axios";
//
// export const BaseUrl = axios.create({ baseURL: `http://localhost:7020/` });
// export const BaseUrl = axios.create({
//   baseURL: `http://ec2-15-207-240-200.ap-south-1.compute.amazonaws.com:8080/`,
// });
export const BaseUrl = axios.create({
  // baseURL: `https://myleadsapi.bridgebrilliance.com`,
  baseURL: `https://backendapi.myleads.in/`,
});
